<template>
  <BillProduct :billModel="billModel" grouped-imei-by-product />
</template>

<script>
import BillProduct from './BillProduct.vue'

export default {
  name: 'WholesaleBillProduct',
  components: {
    BillProduct,
  },
  props: {
    billModel: {
      type: Object,
      required: true,
    },
  },
}
</script>
